import React from "react";

import GridItem from "../../../../../componentsv2/GridItem";

export default function CampoInfo({
  label,
  valor,
  xs = 4,
  sm,
  md,
  lg,
  bloco = false,
  italico = false,
  semGrid = false,
}) {
  const conteudo = (
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          fontSize: "11px",
          fontWeight: 500,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "#999999",
          marginBottom: "6px",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "15px",
          fontWeight: italico ? 400 : 600,
          color: italico ? "#666666" : "#333344",
          lineHeight: 1.45,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          fontStyle: italico ? "italic" : "normal",
          whiteSpace: bloco ? "pre-wrap" : "normal",
        }}
      >
        {valor}
      </div>
    </div>
  );

  if (semGrid) {
    return conteudo;
  }

  const gridProps = { xs: bloco ? 12 : xs ?? 12 };
  if (sm) gridProps.sm = sm;
  if (md) gridProps.md = md;
  if (lg) gridProps.lg = lg;

  return <GridItem {...gridProps}>{conteudo}</GridItem>;
}

